import BasicService from "./BasicService";

class CarGateService extends BasicService {
  constructor() {
    super();
  }

  getCarGateByItemId(itemId) {
    let url = `/orders/${itemId}/gates`;
    return this.axios.get(url).then(response => response.data);
  }

  saveCarGate(
    itemId,
    carGate = {
      gateId: Number,
      transactionId: Number,
      amount: Number,
      receive: Number,
      balance: Number,
      gateRemark: String
    }
  ) {
    let url = `/orders/${itemId}/gates`;
    return this.axios.post(url, carGate).then(response => response.data);
  }

  updateCarGate(
    itemId,
    gateId,
    carGate = {
      gateId: Number,
      transactionId: Number,
      amount: Number,
      receive: Number,
      balance: Number,
      gateRemark: String
    }
  ) {
    let url = `/orders/${itemId}/gates/${gateId}`;
    return this.axios.put(url, carGate).then(response => response.data);
  }
}

const cargateService = new CarGateService();
export default cargateService;
